import { Tooltip } from '@mui/material';
import { type FC } from 'react';

type TruncatedRequesterFullNameTextProps = {
	text: string;
	fontSize?: string;
};

const TruncatedRequesterFullNameText: FC<TruncatedRequesterFullNameTextProps> = ({ text = '', fontSize = '12px' }) => {
	return (
		<Tooltip title={text}>
			<div
				style={{
					fontSize,
					maxWidth: '80%',
					lineHeight: '1.5',
					display: '-webkit-box',
					WebkitBoxOrient: 'vertical',
					WebkitLineClamp: 2,
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				}}
			>
				{text}
			</div>
		</Tooltip>
	);
};

export default TruncatedRequesterFullNameText;
